<div class="w-full max-w-[505px] rounded-3xl bg-background-white px-6 pb-8 pt-8">
  <div class="relative mb-6">
    <h4 class="typo-h1 w-full text-center text-text-primary">{{ 'account_eaglesoft_password_modal_title' | translate }}</h4>
    <button type="button" class="absolute right-0 top-0 text-text-tertiary" (click)="onCancel()">
      <svg-icon key="px-16-x" [fontSize]="16"></svg-icon>
    </button>
  </div>

  <p class="typo-h4-thin mb-2 text-text-secondary">
    {{ 'account_eaglesoft_password_modal_description_1' | translate }}
  </p>
  <p class="typo-h4-thin mb-6 text-text-secondary">
    {{ 'account_eaglesoft_password_modal_description_2' | translate }}
  </p>

  @if (dialogData.warnAboutDataLoss) {
    <p class="typo-h4-thin mb-6 font-semibold text-states-red">
      {{ 'account_eaglesoft_password_modal_data_loss_warning' | translate }}
    </p>
  }

  <form class="flex flex-col gap-6" [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
    <lib-input
      formControlName="password"
      [type]="isPasswordVisible() ? 'text' : 'password'"
      [label]="'account_eaglesoft_password_modal_password_label' | translate"
      [state]="passwordErrorKey('password') ? 'error' : 'normal'"
      [hint]="passwordErrorKey('password') ? (passwordErrorKey('password')! | translate) : ''"
      size="large"
    >
      <svg-icon
        rightIcon
        size="md"
        [key]="isPasswordVisible() ? 'px-24-password-false' : 'px-24-password-true'"
        class="hover:cursor-pointer"
        (click)="togglePasswordVisibility()"
      ></svg-icon>
    </lib-input>

    <lib-input
      formControlName="confirmPassword"
      [type]="isPasswordVisible() ? 'text' : 'password'"
      [label]="'account_eaglesoft_password_modal_confirm_label' | translate"
      [state]="passwordErrorKey('confirmPassword') || isConfirmPasswordMismatched() ? 'error' : 'normal'"
      [hint]="
        passwordErrorKey('confirmPassword')
          ? (passwordErrorKey('confirmPassword')! | translate)
          : isConfirmPasswordMismatched()
            ? ('account_eaglesoft_password_error_no_match' | translate)
            : ''
      "
      size="large"
    >
      <svg-icon
        rightIcon
        size="md"
        [key]="isPasswordVisible() ? 'px-24-password-false' : 'px-24-password-true'"
        class="hover:cursor-pointer"
        (click)="togglePasswordVisibility()"
      ></svg-icon>
    </lib-input>

    @if (hasSubmitFailed()) {
      <p class="typo-h7-light font-semibold text-states-red">{{ 'account_eaglesoft_password_modal_update_error' | translate }}</p>
    }

    <div class="mt-4 flex justify-end gap-4">
      <button type="button" class="btn-secondary h-8 px-4" (click)="onCancel()">
        {{ 'account_eaglesoft_password_modal_cancel' | translate }}
      </button>
      <button type="submit" class="btn-primary h-8 px-4" [disabled]="isSubmitting()">
        {{ 'account_eaglesoft_password_modal_submit' | translate }}
      </button>
    </div>
  </form>
</div>
